import React, { Component } from "react";
import { Checkbox, Radio, Space, Spin, message, Input } from "antd";
import Bridge from "../../../../utils/Bridge";
import englishJson from "../../../../utils/language/leStudy/english.json";
import spanishJson from "../../../../utils/language/leStudy/spanish.json";
import {
  LE_STUDY_DEMOGRAPHICS_CONTENT,
  RESEARCH_TYPE,
} from "../../../../utils/consts";

const { TextArea } = Input;

export default class GenderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gender: "",
      race: [],
      race_other_specification: "",
      ethnicity: "",
      ethnicity_other_specification: "",
      loading: false,
      ethnicity_option_list: [
        "Not of Hispanic, Latino/a or Spanish origin",
        "Mexican, Mexican American, Chicano/a",
        "Puerto Rican",
        "Cuban",
        "Another Hispanic Latino/a or Spanish origin",
        "Other",
        "Decline to answer",
      ],

      biological_sex: "",
      gender_identity: "",
      other_gender_identity: "",
      ethnic_category: "",
      date_of_birth: null,
      ethnicity_other_specification: "",
      other_race: "",
      other_physical_sex_at_birth: "",
      gender_identity: "",
      gender_identity_other_specification: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Physical sex at birth") {
                this.setState({ biological_sex: item.value });
              }
              if (item.field == "Gender Identity") {
                this.setState({ gender_identity: item.value || "" });
              }
              if (item.field == "Other Gender Identity") {
                this.setState({
                  other_gender_identity: item.value || "",
                });
              }
              if (item.field == "Ethnicity") {
                this.setState({
                  ethnic_category: item.value ? item.value : "",
                });
              }
              if (item.field == "Race") {
                this.setState({
                  race: item.value ? JSON.parse(item.value) : [],
                });
              }
              if (item.field == "Other Physical Sex at Birth") {
                this.setState({
                  other_physical_sex_at_birth: item.value || "",
                });
              }
              if (item.field == "Other Race") {
                this.setState({ other_race: item.value });
              }
              if (item.field == "Gender Identity") {
                this.setState({ gender_identity: item.value || "" });
              }
              if (item.field == "Other Gender Identity") {
                this.setState({ gender_identity_other_specification: item.value || "" });
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  save = () => {
    if (!this.state.biological_sex) {
      message.warning("Physical sex at birth is required");
      return;
    }
    if (!this.state.gender_identity) {
      message.warning("Gender Identity is required");
      return;
    }
    if (
      !this.state.ethnic_category ||
      this.state.ethnic_category.trim() === ""
    ) {
      message.warning("Ethnicity is required");
      return;
    }
    if (this.state.race.length === 0) {
      message.warning("Race is required");
      return;
    }
    // step 2
    let questions = [
      {
        parent_field: "Physical sex at birth",
        field: "Physical sex at birth",
        value: this.state.biological_sex,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "physicalSexAtBirth"
          )?.content.find(
            (item) => item.subtitle?.trim() == this.state.biological_sex?.trim()
          )?.subId || "",
      },
      {
        parent_field: "Gender Identity",
        field: "Gender Identity",
        value: this.state.gender_identity,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "genderIdentity"
          )?.content.find(
            (item) =>
              item.subtitle?.trim() == this.state.gender_identity?.trim()
          )?.subId || "",
      },
      {
        parent_field: "Gender Identity",
        field: "Gender Identity",
        value: this.state.gender_identity,
        subId:
        LE_STUDY_DEMOGRAPHICS_CONTENT.find(
          (item) => item.field == "genderIdentity"
        )?.content.find(
          (item) =>
            item.subtitle?.trim() == this.state.gender_identity?.trim()
        )?.subId || "",
      },
      {
        parent_field: "Other Gender Identity",
        field: "Other Gender Identity",
        value: this.state.gender_identity=="Other" ? this.state.gender_identity_other_specification : "",
      },
      {
        parent_field: "Ethnicity",
        field: "Ethnicity",
        value: this.state.ethnic_category ? this.state.ethnic_category : "",
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "ethnicity"
          )?.content.find((item) => item.subtitle == this.state.ethnic_category)
            ?.subId || "",
      },
      {
        parent_field: "Race",
        field: "Race",
        value: this.state.race ? JSON.stringify(this.state.race) : "",
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "race"
          )?.content.find((item) => this.state.race.includes(item.subtitle))
            ?.subId || "",
      },
      {
        parent_field: "Other Physical Sex at Birth",
        field: "Other Physical Sex at Birth",
        value: this.state.other_physical_sex_at_birth,
      },
      {
        parent_field: "Other Gender Identity",
        field: "Other Gender Identity",
        value: this.state.other_gender_identity,
      },
      {
        parent_field: "Other Race",
        field: "Other Race",
        value: this.state.other_race,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "2",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          const formData =
            RESEARCH_TYPE == "LE Study"
              ? this.props.language == "English"
                ? englishJson
                : spanishJson
              : englishJson;
          message.success(
            formData.page.demographicQuestions.messages
              .demographicsDataAddedSuccessfully
          );
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(4);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onHandleChangeRace = (e) => {
    let value = e.target.value;
    let tempArr = this.state.race.length > 0 ? this.state.race : [];
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      if (!newArray.includes("Other")) {
        this.setState({ other_race: "" });
      }
      this.setState({
        race: newArray,
      });
    } else {
      tempArr.push(value);
      this.setState({
        race: tempArr,
      });
    }
  };
  render() {
    const formData =
      this.props.language == "English" ? englishJson : spanishJson;
    return (
      <div>
        <div className="header">
          <h3>
            {
              formData.page.demographicQuestions.fields.genderRaceEthnicity
                .innerTitle
            }
          </h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <p className="manadatory-note">
              <strong className="text-danger">
                {formData.page.demographicQuestions.note}:
              </strong>{" "}
              {formData.page.demographicQuestions.allFieldsMandatory}
            </p>
            <div className="form-group">
              <label className="input-heading">
                {
                  formData.page.demographicQuestions.fields.genderRaceEthnicity
                    .physicalSexAtBirth
                }
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    biological_sex: e.target.value,
                    other_physical_sex_at_birth: "",
                  })
                }
                value={this.state.biological_sex}
              >
                <Space direction="vertical">
                  {formData.page.demographicQuestions.fields.genderRaceEthnicity.physicalSexAtBirthOptions.map(
                    (item, index) => {
                      return (
                        <Radio key={item.value} value={item.value}>
                          {item.label}
                        </Radio>
                      );
                    }
                  )}
                </Space>
              </Radio.Group>
              {this.state.biological_sex == "Other" && (
                <div className="mt-3">
                  <label className="mb-2">
                    {
                      formData.page.demographicQuestions.fields
                        .genderRaceEthnicity.otherPhysicalSexAtBirth
                    }
                  </label>
                  <br />
                  <Input
                    onChange={(e) =>
                      this.setState({
                        other_physical_sex_at_birth: e.target.value,
                      })
                    }
                    value={this.state.other_physical_sex_at_birth}
                    className="demographics-field-height mb-0"
                  />
                </div>
              )}
            </div>
            <div className="form-group">
              <label className="input-heading">
                {
                  formData.page.demographicQuestions.fields.genderRaceEthnicity
                    .genderIdentity
                }
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    gender_identity: e.target.value,
                    other_gender_identity: "",
                  })
                }
                value={this.state.gender_identity}
              >
                <Space direction="vertical">
                  {formData.page.demographicQuestions.fields.genderRaceEthnicity.genderIdentityOptions.map(
                    (item, index) => {
                      return (
                        <Radio key={item.value} value={item.value}>
                          {item.label}
                        </Radio>
                      );
                    }
                  )}
                </Space>
              </Radio.Group>
              {this.state.gender_identity == "Other" && (
                <div className="mt-3">
                  <label className="mb-2">
                    {
                      formData.page.demographicQuestions.fields
                        .genderRaceEthnicity.otherGenderIdentity
                    }
                  </label>
                  <br />
                  <Input
                    onChange={(e) =>
                      this.setState({
                        other_gender_identity: e.target.value,
                      })
                    }
                    value={this.state.other_gender_identity}
                    className="demographics-field-height mb-0"
                  />
                </div>
              )}
            </div>
            <div className="form-group">
              <label className="input-heading">
                {
                  formData.page.demographicQuestions.fields.genderRaceEthnicity
                    .ethnicity
                }
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    ethnic_category: e.target.value,
                  })
                }
                value={this.state.ethnic_category}
                direction="vertical"
              >
                <Space direction="vertical">
                  {formData.page.demographicQuestions.fields.genderRaceEthnicity.ethnicityOptions.map(
                    (item, index) => {
                      return <Radio value={item.value}>{item.label}</Radio>;
                    }
                  )}
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="input-heading">
                {
                  formData.page.demographicQuestions.fields.genderRaceEthnicity
                    .race
                }{" "}
                &nbsp;
                <i style={{ fontWeight: "400" }}>
                  (select all that apply)
                </i>{" "}
              </label>
              <ul>
                {formData.page.demographicQuestions.fields.genderRaceEthnicity.raceOptions.map(
                  (item, index) => {
                    return (
                      <li className="pb-1">
                        <Checkbox
                          checked={
                            this.state.race.includes(item.value) ? true : false
                          }
                          value={item.value}
                          onChange={(e) => this.onHandleChangeRace(e)}
                        >
                          {item.label}
                        </Checkbox>
                      </li>
                    );
                  }
                )}
              </ul>
              {this.state.race.includes("Other") && (
                <div className="mt-3">
                  <label className="mb-2">
                    {
                      formData.page.demographicQuestions.fields
                        .genderRaceEthnicity.raceOtherSpecification
                    }
                  </label>
                  <br />
                  <input
                    type="text"
                    name="other_race"
                    value={this.state.other_race}
                    onChange={(e) =>
                      this.setState({ other_race: e.target.value })
                    }
                    maxLength={30}
                  />
                </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button"
                  style={{
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  {formData.page.demographicQuestions.button.save}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(1)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  {formData.page.demographicQuestions.button.previous}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  {formData.page.demographicQuestions.button.savenext}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
